import React, { useEffect, useState } from "react";
import { Star, Quote, Loader2 } from "lucide-react";
import { publicApi } from "../lib/api";

/**
 * Public 5-star testimonial wall used on the landing + windscreens pages.
 * Only pulls approved testimonials from the backend (permission_to_publish=true).
 */
export const TestimonialWall = () => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    (async () => {
      try { setRows(await publicApi.listPublicTestimonials(9)); }
      catch { setRows([]); }
    })();
  }, []);

  if (rows === null) {
    return (
      <section className="bg-white py-16" data-testid="testimonial-wall-loading">
        <div className="max-w-6xl mx-auto px-4 text-center text-[#3f4b52]">
          <Loader2 className="animate-spin inline-block" size={18} />
        </div>
      </section>
    );
  }
  if (rows.length === 0) return null;

  return (
    <section className="bg-[#f5f6f6] py-20 border-y border-[#e0e5e7]" data-testid="testimonial-wall">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-[#f28a16]/10 text-[#f28a16] px-3 py-1 rounded-sm text-xs font-display uppercase tracking-widest">
            <Star size={12} className="fill-[#f28a16]" /> Real reviews
          </div>
          <h2 className="mt-3 font-display font-black uppercase text-3xl sm:text-4xl text-[#111619]">
            What our customers say
          </h2>
          <p className="mt-2 text-[#3f4b52] text-sm">
            Reviews shared at the point of fitment — with the client's written permission.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {rows.map((t) => (
            <blockquote
              key={t.id}
              data-testid={`testimonial-card-${t.id}`}
              className="bg-white border border-[#cfd7db] rounded-md p-5 shadow-sm relative overflow-hidden"
            >
              <Quote size={40} className="absolute top-3 right-3 text-[#f28a16]/10" />
              <div className="flex items-center gap-0.5 mb-2">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star key={n} size={14} className={n <= t.rating ? "fill-[#f28a16] text-[#f28a16]" : "text-[#cfd7db]"} />
                ))}
              </div>
              {t.comment && (
                <p className="text-sm text-[#111619] italic leading-relaxed">"{t.comment}"</p>
              )}
              <footer className="mt-4 pt-3 border-t border-[#eef2f4] text-xs text-[#3f4b52]">
                <b className="text-[#111619]">{t.author_name || "Anonymous"}</b>
                {t.approved_at && (
                  <span className="ml-2 text-[#9aa6ad]">
                    · {new Date(t.approved_at).toLocaleDateString("en-ZA", { month: "short", year: "numeric" })}
                  </span>
                )}
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialWall;
